import axios from 'axios';
import config from '../../../assets/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from '../authHeader';

const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const userGroupGrid = createAsyncThunk(
    'usergroup-grid',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/GetEntUserGroupList`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const memberList = createAsyncThunk(
    'member-list',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/GetEntUserGroupMembers`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
export const assoMemList = createAsyncThunk(
    'assoc-member-list',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/GetEntUserGroupMembers`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
export const addUserMember = createAsyncThunk(
    'add-member',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}Security/AddUserGroupMember`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
export const deleteMember = createAsyncThunk(
    'delete-member',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/DeleteUserGroupMember/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);
export const associateServices = createAsyncThunk(
    'associate-services',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetAssocUserGroupServices/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);
export const serviceUserGroup = createAsyncThunk(
    'usergroup-services',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetServiceUserGroup/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);
export const UpdateServiceUserGroup = createAsyncThunk(
    'updateusergroup-services',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/UpdateServiceUserGroup`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const addUserGroup = createAsyncThunk(
    'usergroup-add',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/CreateUserGroup`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const roleMenuService = createAsyncThunk(
    'role-menu-srvice',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetRoleToMenuServices/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const changeGroupStatus = createAsyncThunk(
    'user-group-status',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/SwitchUserGroupStatus`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const deleteUserGrp = createAsyncThunk(
    'user-group-delete',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/DeleteUserGroup`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
// GetAssocateUserGroupServices,CreateUserGroup,GetRoleToMenuServices,SwitchUserGroupStatus,DeleteUserGroup